export const USER_CHECK_LOGIN = 'USER_CHECK_LOGIN';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_NOT_LOGGED_IN = 'USER_NOT_LOGGED_IN';

export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';

export const FILES_DROPPED = 'FILES_DROPPED';
export const FILES_CLEAR_ONE = 'FILES_CLEAR_ONE';
export const FILES_CLEAR = 'FILES_CLEAR';
export const FILES_ADD_KEYWORD = 'FILES_ADD_KEYWORD';
export const FILES_UPDATE_FIELD = 'FILES_UPDATE_FIELD';
export const FILES_REMOVE_KEYWORD = 'FILES_REMOVE_KEYWORD';
export const FILES_UPLOAD_STARTED = 'FILES_UPLOAD_STARTED';
export const FILES_UPLOAD_CANCELLED = 'FILES_UPLOAD_CANCELLED';
export const FILES_UPLOAD_COMPLETED = 'FILES_UPLOAD_COMPLETED';
export const FILES_ENABLE_UPLOAD = 'FILES_ENABLE_UPLOAD';
export const FILES_DISABLE_UPLOAD = 'FILES_DISABLE_UPLOAD';
export const FILES_META_LOADED = 'FILES_META_LOADED';
export const FILES_META_ERROR = 'FILES_META_ERROR';
export const FILES_META_SHOW = 'FILES_META_SHOW';
export const FILES_META_HIDE = 'FILES_META_HIDE';
export const FILES_META_MERGE = 'FILES_META_MERGE';
export const FILES_SUGGESTION_HIDE = 'FILES_SUGGESTION_HIDE';
export const FILES_SUGGESTION_SHOW = 'FILES_SUGGESTION_SHOW';
export const FILES_ADD_IMAGE_SUGGESTIONS = 'FILES_ADD_IMAGE_SUGGESTIONS';
export const FILES_FETCHING_IMAGE_SUGGESTIONS = 'FILES_FETCHING_IMAGE_SUGGESTIONS';
export const FILES_FETCHED_IMAGE_SUGGESTIONS = 'FILES_FETCHED_IMAGE_SUGGESTIONS';
export const FILES_FETCH_ERROR_IMAGE_SUGGESTIONS = 'FILES_FETCH_ERROR_IMAGE_SUGGESTIONS';
export const FILES_SAVE_TEMP_PATH = 'FILES_SAVE_TEMP_PATH';
export const FILES_FETCHED_IMAGE_SUGGESTIONS_WITH_EXIF = 'FILES_FETCHED_IMAGE_SUGGESTIONS_WITH_EXIF';
export const FILES_SHOW_IMAGE_SUGGESTION_MODAL = 'FILES_SHOW_IMAGE_SUGGESTION_MODAL';
export const FILES_HIDE_IMAGE_SUGGESTION_MODAL = 'FILES_HIDE_IMAGE_SUGGESTION_MODAL';

export const IMAGE_LIST_ADD = 'IMAGE_LIST_ADD';
export const IMAGE_LIST_APPEND = 'IMAGE_LIST_APPEND';
export const IMAGE_LIST_FETCHING = 'IMAGE_LIST_FETCHING';
export const IMAGE_LIST_FETCHED = 'IMAGE_LIST_FETCHED';
export const IMAGE_LIST_FETCH_CANCELLED = 'IMAGE_LIST_FETCH_CANCELLED';
export const IMAGE_LIST_LIMIT_REACHED = 'IMAGE_LIST_LIMIT_REACHED';
export const IMAGE_LIST_RESET = 'IMAGE_LIST_RESET';

export const CROP_IMAGE_LOADING = 'CROP_IMAGE_LOADING';
export const CROP_IMAGE_LOADED = 'CROP_IMAGE_LOADED';
export const CROP_IMAGE_LOAD_CANCELLED = 'CROP_IMAGE_LOAD_CANCELLED';
export const CROP_IMAGE_ADD_NEW_CROP = 'CROP_IMAGE_ADD_NEW_CROP';
export const CROP_IMAGE_RESET_CROPS = 'CROP_IMAGE_RESET_CROPS';
export const CROP_IMAGE_START_UPLOADING = 'CROP_IMAGE_START_UPLOADING';
export const CROP_IMAGE_UPLOADED = 'CROP_IMAGE_UPLOADED';
export const CROP_IMAGE_CROPPING_CANCELLED = 'CROP_IMAGE_CROPPING_CANCELLED';
export const CROP_CLEAR_CROPS = 'CROP_CLEAR_CROPS';

export const GROUP_GET_INFO = 'GROUP_GET_INFO';
export const GROUP_ADD_NEW = 'GROUP_ADD_NEW';
export const GROUP_ADD_MULTIPLE = 'GROUP_ADD_MULTIPLE';
export const GROUP_ADD_NEW_SIZE_TO_GROUP = 'GROUP_ADD_NEW_SIZE_TO_GROUP';
export const GROUP_DELETE_SIZE_FROM_GROUP = 'GROUP_DELETE_SIZE_FROM_GROUP';


export const SEARCH_START = 'SEARCH_START';
export const SEARCH_END = 'SEARCH_END';
export const SEARCH_CANCELLED = 'SEARCH_CANCELLED';
export const SEARCH_RESET = 'SEARCH_RESET';

export const IMAGE_FILE_RESET = 'IMAGE_FILE_RESET';
export const IMAGE_FILE_DATA_LOADING = 'IMAGE_FILE_DATA_LOADING';
export const IMAGE_FILE_DATA_LOADED = 'IMAGE_FILE_DATA_LOADED';
export const IMAGE_FILE_DATA_LOAD_FAILED = 'IMAGE_FILE_DATA_LOAD_FAILED';
export const IMAGE_FILE_SAVING = 'IMAGE_FILE_SAVING';
export const IMAGE_FILE_SAVED = 'IMAGE_FILE_SAVED';
export const IMAGE_FILE_SAVE_FAILED = 'IMAGE_FILE_SAVE_FAILED';
export const IMAGE_FILE_CROPS_LOADING = 'IMAGE_FILE_CROPS_LOADING';
export const IMAGE_FILE_CROPS_LOADED = 'IMAGE_FILE_CROPS_LOADED';
export const IMAGE_FILE_CROPS_LOAD_FAILED = 'IMAGE_FILE_CROPS_LOAD_FAILED';
export const IMAGE_FILE_TOGGLE_EDITABLE = 'IMAGE_FILE_TOGGLE_EDITABLE';
export const IMAGE_FILE_ADD_KEYWORD = 'IMAGE_FILE_ADD_KEYWORD';
export const IMAGE_FILE_REMOVE_KEYWORD = 'IMAGE_FILE_REMOVE_KEYWORD';
export const IMAGE_FILE_UPDATE_FIELD = 'IMAGE_FILE_UPDATE_FIELD';

export const IMAGE_DELETE = 'IMAGE_DELETE';



/** WEBPACK FOOTER **
 ** ./constants/actiontypes.js
 **/